const article = `
{settings}
document.title: Terrorgruppen IS tappar mark
og.title: Interaktiv grafik: Terrorgruppen IS tappar mark
og.image: http://pejl.svt.se/img/IS-Oktober2016.jpg
og.description: Den militanta terrorgruppen IS utbredning över Syrien och Irak tycks ha avtagit efter den senaste tidens förluster av viktiga områden. Offensiven mot Mosul är den senaste i raden av motgångarna

og.url: http://pejl.svt.se/is-fore-efter/
siteCatalyst.name: is-fore-efter
siteCatalyst.category: lyxartikel
{}

[+page]
rubrik2: Terrorgruppen IS tappar mark

ingress: Den militanta terrorgruppen IS utbredning över Syrien och Irak tycks ha avtagit efter den senaste tidens förluster av viktiga områden. Offensiven mot Mosul är den senaste i raden av motgångarna

{.iframe}
src: http://pejl.svt.se/is-fore-efter-iframe/
storlek:page
height:56.25%
bildtext: Dra i pilen för att jämföra IS utbredning mellan 2015 och 2016.
credit: Källa: BBC/IHS Conflict Monitor
{}

Så sent som i helgen förlorade IS den symboliskt viktiga staden Dabiq i syriska Aleppoprovinsen till syriska rebeller understödda av turkisk militär. Enligt en rapport som BBC tagit del av hade terrorgruppen i oktober i år förlorat omkring 16 procent av sitt kontrollerade område sedan i början av året. 
Det IS-kontrollerade territoriet ska ha minskat med över en fjärdedel sedan 2015 och enligt en Pentagonrapport från i maj i år ska IS har förlorat omkring hälften av den markyta gruppen tidigare kontrollerat i Irak, däribland städerna al-Falluja och al-Ramadi. I takt med att IS tappat mark har gruppen svarat med terrordåd i bland annat Bagdad, Istanbul och Nice, med hundratals döda och skadade som följd.
Det var 2014 som IS invaderade norra Irak och staden Mosul och fortsatte sin framfart söderut. Som mest har cirka tio miljoner människor levt under IS-kontrollerat territorium. I dag ska den siffran vara nere på sex miljoner, enligt BBC.

linje:

text: [Reporter: Karina Morberg | strong], [karina.morberg@svt.se | mailto:karina.morberg@svt.se]
text: [Grafik: Helena Jonsson | strong], [helena.jonsson@svt.se | mailto:helena.jonsson@svt.se]

{.sharebuttons}
title:Interaktiv grafik: Terrorgruppen IS tappar mark
url:http://pejl.svt.se/is-fore-efter/
{}

[]
`;

export default article;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/articles/is-fore-efter.js
 **/